import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import useNewSearch from "hooks/newSearch"
import { CircularProgress } from "@material-ui/core"
import i18n from "i18n"

import Part from "./part"
import { HelveticaBold } from "common/typographies"
import DropdownSelectBank from "./dropdownSelectBank"

const PriceSearcher = ({
  partidaState,
  setPartidaState,
  setDetails,
  details,
  setContent,
}) => {
  const { results, loadingSearch, getResults } = useNewSearch()
  const [loading, setLoading] = useState(false)
  const [bankSelected, setBankSelected] = useState("cype")

  useEffect(() => {
    setIteration(0)
    setSearchingSimilar(false)
    setIsInitialSearch(true)
    getData(partidaState.name)
  }, [bankSelected])

  const [resultsToShow, setResultsToShow] = useState([])
  const [iteration, setIteration] = useState(0)
  const [searchingSimilar, setSearchingSimilar] = useState(false)
  const [isInitialSearch, setIsInitialSearch] = useState(true)

  const bankConfig = {
    cype: [
      "Rehabilitación",
      "PARTIDAS DE OBRA Y CONJUNTOS",
      "PRECIOS UNITARIOS",
    ],
    bedec: [
      "PARTIDAS DE OBRA Y CONJUNTOS",
      "MAQUINARIA",
      "MATERIALES Y COMPUESTOS",
      "MANO DE OBRA",
    ],
    preoc: ["PRECIOS UNITARIOS", "PRECIOS AUXILIARES", "PRECIOS DESCOMPUESTOS"],
  }

  const processResults = allResults => {
    const partsList = []
    allResults.forEach(result => {
      if (result?.length > 0) {
        for (let i = 0; i < result.length; i++) {
          if (result[i].parts) {
            for (let j = 0; j < result[i].parts.length; j++) {
              partsList.push(result[i].parts[j].partInfo)
            }
          }
        }
      }
    })
    return partsList
  }

  const getData = async name => {
    let partsList = []
    setLoading(true)

    const categories = bankConfig[bankSelected]

    const allResults = await Promise.all(
      categories.map(category => getResults(name, bankSelected, category)),
    )

    partsList = processResults(allResults)

    if (partsList.length > 0) {
      setResultsToShow(partsList)
      setLoading(false)
      setIsInitialSearch(true)
    } else {
      if (!searchingSimilar) {
        setSearchingSimilar(true)
        setIsInitialSearch(false)
      }
      if (iteration < 3) {
        setIteration(iteration + 1)
        let newName = name
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .replace(/[^a-zA-Z ]/g, "")
        let lastSpaceIndex = newName.lastIndexOf(" ")

        if (lastSpaceIndex > 0) {
          let newName2 = newName.substring(0, lastSpaceIndex)
          setTimeout(() => {
            getData(newName2)
          }, 0)
          return
        } else {
          setResultsToShow(partsList)
          setLoading(false)
        }
      } else {
        setResultsToShow(partsList)
        setLoading(false)
      }
    }
  }

  const calcHeight = () => {
    if (window.innerHeight < 800) {
      return "360px"
    } else if (window.innerHeight < 1000) {
      return "600px"
    }
  }

  return (
    <>
      <DropdownSelectBank
        bankSelected={bankSelected}
        setBankSelected={setBankSelected}
      />
      {loading ? (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
          }}
        >
          <CircularProgress />
          <HelveticaBold
            style={{
              color: "#414141",
              fontSize: "14px",
              marginTop: "10px",
              marginBottom: "10px",
            }}
          >
            {isInitialSearch
              ? i18n.t("modalPartida.searchingParts")
              : i18n.t("modalPartida.searchingSimilarParts")}
          </HelveticaBold>
        </div>
      ) : (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            height: calcHeight(),
            overflow: "auto",
          }}
        >
          {resultsToShow.length > 0 ? (
            resultsToShow.map((part, i) => (
              <Part
                key={i}
                partidaState={partidaState}
                setPartidaState={setPartidaState}
                part={part}
                i={i}
                setDetails={setDetails}
                details={details}
                setContent={setContent}
              />
            ))
          ) : (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
              }}
            >
              <HelveticaBold
                style={{
                  color: "#414141",
                  fontSize: "14px",
                  marginTop: "0px",
                  marginBottom: "10px",
                }}
              >
                {i18n.t("modalPartida.searchingNoResults")}
              </HelveticaBold>
            </div>
          )}
        </div>
      )}
    </>
  )
}

PriceSearcher.propTypes = {
  partidaState: PropTypes.object.isRequired,
  setPartidaState: PropTypes.func.isRequired,
  setDetails: PropTypes.func.isRequired,
  details: PropTypes.array.isRequired,
  setContent: PropTypes.func.isRequired,
}

export default PriceSearcher
